// extracted by mini-css-extract-plugin
export default {"heading":"DeductionDetailsHeader_heading__vpn2K","grid":"DeductionDetailsHeader_grid__YPbHM"};